import { Typography } from '@mui/material';
import { Box } from '@mui/system';
import React from 'react';
import { DotIcon } from './therapist-dashboard/todays-activity/task-deatails';

type GoalsCategory = 'SHORT_TERM' | 'LONG_TERM';

type GoalsData = {
  [key in GoalsCategory]: string[];
};

type GoalsObject = {
  [key: string]: GoalsData;
};

type Props = {
  discipline: 'OT' | 'PT' | 'SLP';
  isShortTerm: boolean;
  goals: string[];
  data?: GoalsObject;
};

const PatientGoalInfo = (props: Props) => {
  const { discipline, isShortTerm, goals, data } = props;

  return (
    <Box mt={1}>
      {' '}
      <Typography variant="subtitle2">{isShortTerm ? discipline : null}</Typography>
      <Box sx={{ flexWrap: 'wrap' }}>
        <Typography
          variant="paragraphHeading"
          color="primary"
        >
          {' '}
          {isShortTerm ? 'Short Term :' : 'Long Term :'}
        </Typography>

        {goals?.map((goal: any, index: any) => (
            <Box
              sx={{ display: 'flex', ml: '7px', alignItems: 'center', gap: 0.5 }}
              key={index}
            >
              <DotIcon />
              <Typography
                key={index}
                variant="body2"
              >
                {index + 1}.{goal}
              </Typography>
            </Box>
          ))
        }
      </Box>
    </Box>
  );
};
export default PatientGoalInfo;